import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import user from 'src/js/modules/user';
import config from 'src/js/modules/config';
import redirectToUrl from 'src/js/utils/redirect-to-url';
import redirectToNext from 'src/js/common/helpers/redirect-to-next';

const withAuthRedirect = (WrappedComponent) => {
  const WithAuthRedirect = (props) => {
    const dashboardURL = useSelector(config.selectors.getDashboardURL);

    useEffect(() => {
      const isAuthenticated = user.verifiers.isAuthenticated();

      if (isAuthenticated) {
        const redirectedToNext = redirectToNext();

        if (!redirectedToNext) {
          redirectToUrl(dashboardURL);
        }
      }
    }, [dashboardURL]);

    return <WrappedComponent {...props} />;
  };

  return WithAuthRedirect;
};

export default withAuthRedirect;
